/** Префикс дев-прокси хранилища в `src/setupProxy.js`. */
export const STORAGE_PROXY_PREFIX = '/__storage';

const STORAGE_HOST_SUFFIX = '.storage.yandexcloud.net';

/** Картинка лежит в нашем хранилище, а не на чужом сайте (бывает у эмблем, залитых ссылкой). */
export function isStorageUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && parsed.hostname.endsWith(STORAGE_HOST_SUFFIX);
  } catch {
    return false;
  }
}

/**
 * Адрес, по которому картинку из хранилища можно скачать из браузера.
 *
 * Бакет отдаёт CORS только задеплоенным админкам, а `localhost` не пускает — поэтому под
 * дев-сервером запрос идёт через его прокси (`/__storage/<host>/<path>`). В собранном
 * бандле `isLocal` — константа `false`, и адрес возвращается как есть.
 */
export function toFetchableStorageUrl(url: string, isLocal = process.env.NODE_ENV === 'development'): string {
  if (!isLocal || !isStorageUrl(url)) return url;

  const parsed = new URL(url);
  return `${STORAGE_PROXY_PREFIX}/${parsed.hostname}${parsed.pathname}${parsed.search}`;
}
